export * from './useResourceDetail2';
